import { MessageCircle, Phone, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { waLink, renderLinkedText } from "@/lib/content";
import { scrollTo } from "@/components/Navbar";

export const Footer = () => {
  const { content } = useContent();
  return (
  <footer className="bg-[#1C1917] pb-12 pt-24" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-display text-3xl font-medium tracking-tight text-[#FAF8F5] sm:text-4xl">
            {content.business.name}
          </p>
          <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.3em] text-[#C5A059]">
            {content.site.tagline}
          </p>
          <p className="mt-3 font-display text-lg italic text-[#C5A059]">
            {content.footer.punjabi_tagline}
          </p>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#FAF8F5]/60">
            {renderLinkedText(content.footer.blurb)}
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-[#C5A059]">
            Reach Us
          </p>
          <div className="space-y-4">
            <a
              href={`tel:${content.business.phone_display.replace(/\s/g, "")}`}
              data-testid="footer-phone-link"
              className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 transition-colors hover:text-[#C5A059]"
            >
              <Phone size={16} /> {content.business.phone_display}
            </a>
            <a
              href={waLink(content.business.whatsapp_number, content.enquiry.whatsapp_msg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 transition-colors hover:text-[#C5A059]"
            >
              <MessageCircle size={16} /> WhatsApp us anytime
            </a>
            <p className="flex items-center gap-3 text-sm text-[#FAF8F5]/80">
              <MapPin size={16} /> {content.business.service_areas}
            </p>
            {content.business.instagram && (
              <a href={content.business.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 transition-colors hover:text-[#C5A059]">
                <Instagram size={16} /> Follow us on Instagram
              </a>
            )}
            {content.business.facebook && (
              <a href={content.business.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 transition-colors hover:text-[#C5A059]">
                <Facebook size={16} /> Follow us on Facebook
              </a>
            )}
            {content.business.linkedin && (
              <a href={content.business.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 transition-colors hover:text-[#C5A059]">
                <Linkedin size={16} /> Connect on LinkedIn
              </a>
            )}
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-[#C5A059]">
            Explore
          </p>
          <div className="flex flex-col gap-3">
            {[
              ["Our Promise", "#promise"],
              ["Services", "#services"],
              ["Packages", "#packages"],
              ["How It Works", "#how-it-works"],
              ["Enquire", "#enquire"],
            ].map(([label, href]) => (
              <button
                key={href}
                onClick={() => scrollTo(href)}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-left text-sm text-[#FAF8F5]/70 transition-colors hover:text-[#C5A059]"
              >
                {label}
              </button>
            ))}
            <a
              href="/nri-property-management"
              data-testid="footer-link-property-management"
              className="text-left text-sm font-semibold text-[#C5A059]/90 transition-colors hover:text-[#C5A059]"
            >
              NRI Property Management →
            </a>
            <a
              href="/nri-parent-care"
              data-testid="footer-link-parent-care"
              className="text-left text-sm font-semibold text-[#C5A059]/90 transition-colors hover:text-[#C5A059]"
            >
              NRI Parent Care →
            </a>
          </div>
        </div>
      </div>
      <div className="mt-20 flex flex-col gap-3 border-t border-[#FAF8F5]/10 pt-8 text-[11px] uppercase tracking-[0.2em] text-[#FAF8F5]/40 sm:flex-row sm:items-center sm:justify-between">
        <p>{content.footer.copyright || `© ${new Date().getFullYear()} ${content.business.name}`}</p>
        <p>tricityfamilyconcierge.com · tricityfamilyconcierge.in</p>
        <p>Made with love in the Tricity</p>
      </div>
    </div>
  </footer>
  );
};
